import React from 'react';
import Appbar from '../Appbar';
import Footer from '../Footer';

const TermsAndCondition = () => {
    return (
        <div className="flex flex-col min-h-screen w-full">
            <Appbar />
            <div className="p-6 max-w-3xl mx-auto">
                <h1 className="text-2xl font-bold mb-4">Website Terms and Conditions for Wordy Gifts Ltd.</h1>
                <p className="text-sm text-gray-600 mb-6">Last Updated: 20th February 2025</p>

                <p>Welcome to Wordy Gifts Ltd., an online subscription service that delivers personalized messages to recipients over 12 months. By accessing or using the services provided by Wordy Gifts Ltd. ("we", "us", "our"), you ("Customer", "you", "your") agree to comply with and be bound by the following Terms and Conditions. Please read these Terms carefully before using our service.</p>

                <h2 className="text-lg font-semibold mt-6">1. Agreement to Terms</h2>
                <p>By subscribing to our service, you agree to these Terms and Conditions. If you do not agree with any part of these Terms, you must not use our website or services.</p>

                <h2 className="text-lg font-semibold mt-6">2. Service Description</h2>
                <p>Wordy Gifts Ltd. offers a subscription service that sends personalized messages to a designated recipient over a 12-month period. These messages are sent on your behalf, and the content is generated using AI technology.</p>

                <h2 className="text-lg font-semibold mt-6">3. User Information and Consent</h2>
                <ul className="list-disc pl-6">
                    <li>You must provide the recipient's name and phone number and obtain their explicit consent before submitting their details.</li>
                    <li>You are responsible for ensuring the accuracy of the recipient’s information.</li>
                </ul>

                <h2 className="text-lg font-semibold mt-6">4. AI-Generated Messages</h2>
                <ul className="list-disc pl-6">
                    <li>Messages are created using Artificial Intelligence (AI), and we do not guarantee their quality or tone.</li>
                    <li>The messages are for entertainment purposes only.</li>
                </ul>

                <h2 className="text-lg font-semibold mt-6">5. Limitations of Liability</h2>
                <ul className="list-disc pl-6">
                    <li>We are not responsible for any issues related to AI-generated messages.</li>
                    <li>We are not liable for errors in the information you provide.</li>
                </ul>

                <h2 className="text-lg font-semibold mt-6">6. Customer Responsibility</h2>
                <p>You must use our service responsibly and ensure compliance with all applicable laws.</p>

                <h2 className="text-lg font-semibold mt-6">7. Privacy and Data Protection</h2>
                <p>Please refer to our <a href="/privacy-policy" className="text-blue-600 underline">Privacy Policy</a> for details on how we handle personal data.</p>

                <h2 className="text-lg font-semibold mt-6">8. Subscription and Payment</h2>
                <ul className="list-disc pl-6">
                    <li>The service costs a one-time fee of £5, which is non-refundable.</li>
                    <li>Payments are processed securely through Stripe.</li>
                    <li>Subscriptions automatically renew unless canceled before the next billing cycle.</li>
                </ul>

                <h2 className="text-lg font-semibold mt-6">9. Termination of Service</h2>
                <p>You may cancel your subscription at any time, but no refunds will be issued for the current subscription period.</p>

                <h2 className="text-lg font-semibold mt-6">10. Modifications to Terms</h2>
                <p>We may update these Terms and Conditions at any time, with changes posted on our website.</p>

                <h2 className="text-lg font-semibold mt-6">11. Disclaimers</h2>
                <p>Our service is provided "as is" without warranties regarding reliability, accuracy, or completeness.</p>

                <h2 className="text-lg font-semibold mt-6">12. Governing Law</h2>
                <p>These Terms are governed by the laws of the United Kingdom.</p>

                <h2 className="text-lg font-semibold mt-6">13. Contact Information</h2>
                <p>If you have any questions, contact us at <a href="mailto:enquries@wordygift.com" className="text-blue-600 underline">enquries@wordygift.com</a>.</p>
            </div>

            <Footer />
        </div>
    );
};

export default TermsAndCondition;
